module.exports = __webpack_public_path__ + "static/media/united-kingdom.8987950d.svg";